import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Accountings/Document";
import GridConfig from "./GridConfig";
import SelectAsync from 'react-select/async';
import AccountTafsilTransfer from "./Accountings/AccountTafsilTransfer";
import AccountMoeinTransfer from "./Accountings/AccountMoeinTransfer";

export default class TransactionsReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            configName: 'transactions_report',
            systemModuleId: 4,
            moduleAccessStatus: 1,
            parentAccounts: [],
            childAccounts: [],
            followNumbers: '',
            menuId: 125
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.getInit();
            });
    }
    getInit() {
        this.httpPost("/api/v1/common/get", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    refreshData(e) {
        if (!this.isNull(e))
            e.preventDefault();

        if (this.state.moeinId === null || this.state.moeinId === this.getDefaultGuid()) {
            this.showErorrMessage("حساب معینی انتخاب نمایید");
        }

        var parentAccountIds = [];
        var childAccountIds = [];

        this.state.parentAccounts.forEach(f => parentAccountIds.push(f.id));
        this.state.childAccounts.forEach(f => childAccountIds.push(f.id));

        this.httpPost("/api/v1/report/transactions2", {
            parentAccountIds,
            childAccountIds,
            followNumbers: this.state.followNumbers
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "date", caption: "تاریخ", show: true },
                { field: "number", caption: "سند", show: true },
                { field: "followNumber", caption: "شماره پیگیری", show: true },
                { field: "description", caption: "شرح", show: true },
                { field: "bed", caption: "بدهکار", show: true },
                { field: "bes", caption: "بستانکار", show: true },
                { field: "balance", caption: "مانده", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showDocument(props.data.documentId)}>{props.data.number}</a> } });
            if (f.field == 'followNumber' && f.show) t.push({ flex: 1, field: f.field, headerName: f.caption });
            if (f.field == 'description' && f.show) t.push({ flex: 3, field: f.field, headerName: f.caption });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'balance' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.balance) } });
        });
        return t;
    }
    articleTafsilTransfer() {
        var documentItemsId = this.state.selectedIds;
        if (this.isEmpty(documentItemsId)) {
            this.showErorrMessage("انتخاب حداقل یک آرتیکل جهت انتقال الزامی می باشد");
            return;
        }
        this.showComponents({
            component: <AccountTafsilTransfer Caller={this} DocumentItemsId={documentItemsId} OrganizationId={this.state.data.global.company.id} />
        });
    }
    articleMoeinTransfer() {
        var documentItemsId = this.state.selectedIds;
        if (this.isEmpty(documentItemsId)) {
            this.showErorrMessage("انتخاب حداقل یک آرتیکل جهت انتقال الزامی می باشد");
            return;
        }
        this.showComponents({
            component: <AccountMoeinTransfer Caller={this} DocumentItemsId={documentItemsId} />
        });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="container">
            <div className="card card-bordered card-stretch">
                <div className="card-inner position-relative card-tools-toggle">
                    <div className="row">
                        <div className="col-sm-9">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap" style={{ minWidth: "250px" }}>
                                        <SelectAsync
                                            //defaultValue={item.bankAccountId != this.defaultGuid() ? [{ value: item.bankAccountId, label: item.bankAccountName }] : null}
                                            isMulti={true}
                                            placeholder="انتخاب معین ها"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                                            onChange={e => this.state.parentAccounts = e}
                                        />
                                    </div>
                                    <div className="form-wrap" style={{ minWidth: "250px" }}>
                                        <SelectAsync
                                            //defaultValue={item.bankAccountId != this.defaultGuid() ? [{ value: item.bankAccountId, label: item.bankAccountName }] : null}
                                            isMulti={true}
                                            placeholder="انتخاب تفصیل ها"
                                            defaultOptions
                                            isClearable={true}
                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4)}
                                            onChange={e => this.state.childAccounts = e}
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.followNumbers} onChange={e => this.state.followNumbers = e.target.value} placeholder="شماره های پیگیری 1-2-..." className="form-control" />
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {!this.isEmpty(this.state.data.records) && <div className="col-sm-3 text-left">
                            <ul className="nk-block-tools g-3">
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.articleMoeinTransfer()}><span>انتقال معین آرتیکلها</span></a>
                                </li>
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.articleTafsilTransfer()}><span>انتقال تفصیل آرتیکلها</span></a>
                                </li>
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('گردش حساب ها')}><span>چاپ</span></a>
                                </li>
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('گردش حساب ها')}><span>PDF</span></a>
                                </li>
                                <li>
                                    <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('گردش حساب ها')}><span>اکسل</span></a>
                                </li>
                            </ul>
                        </div>}
                    </div>
                </div>
                {!this.isEmpty(this.state.data.records) && this.renderAgGrid({
                    columnDefs: this.getColumns()
                })}
                {!this.isEmpty(this.state.data.records) && <div className="row text-center">
                    <div className="col-sm-4">
                        <p style={{ "color": "green" }}>گردش بدهکار: {this.money(this.state.data.sumBed)}</p>
                    </div>
                    <div className="col-sm-4">
                        <p style={{ "color": "red" }}>گردش بستانکار: {this.money(this.state.data.sumBes)}</p>
                    </div>
                    <div className="col-sm-4">
                        {this.state.data.sumBed >= this.state.data.sumBes ?
                            <p style={{ "color": "blue" }}>مانده: {this.money(this.state.data.sumBed - this.state.data.sumBes)}</p>
                            :
                            <p style={{ "color": "blue" }}>مانده: ({this.money(this.state.data.sumBes - this.state.data.sumBed)})</p>
                        }
                    </div>
                </div>}
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />,
            ];

        return contents;
    }
}